import React, {Component} from 'react';
import {Button,Icon,Input} from 'antd';
import ReactGA from 'react-ga';

import customizeCss from './customizeCss';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

library.add(faCheck);
let hostSelect = null;
let URL_CONFIG = null;
let TXTS_FILE = null;

const stripePK = {
	test:'pk_test_ak6evAVpNI9jS8IkdSB48aHw',
	prod:'pk_live_HzOHYVb9MxUoZGFWYEywqCLA'
};

//let isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1
let isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

let iosLoad = isIos && (window.location.host==='flairisfrench.com' || window.location.host==='fr.perus.co' || window.location.host==='www.perus.co' || window.location.host==='es.perus.co' || window.location.host==="dianavaradi.com");

let lang = "FR";
let slideView = null;

let saveCard = { number : null, exp_month : null, exp_year : null, cvc : null };

let type = 19; // cb par défaut (19), american (17) -> nombre de chiffres + espaces -> maxLength de l'input
let cvcType = 3; // cb par défaut (3), american (4) - nombre de chiffres

let domRoot = document.querySelector("body");
if(document.querySelector("#gRoot") && document.querySelector("#gRoot").shadowRoot) domRoot = document.querySelector("#gRoot").shadowRoot;
else if(document.querySelector("#gRoot")) domRoot = document.querySelector("#gRoot");

function returnHostMode(hostMode) {
    if (hostMode.indexOf("test") !== -1) return "test";
    else return "prod";
}

export default class StripeContainer extends Component{

    constructor(props){
        super(props)
        this.state = {
            validateCGV : false,
            card : saveCard,
            check: false,
            scLang: this.props.lang,
            loading: false
        }

        hostSelect = this.props.hostSelect;
        URL_CONFIG = this.props.URL_CONFIG;
        TXTS_FILE = this.props.TXTS_FILE;
        slideView = this.props.slideView;

        const initReactGAhost = this.props.initReactGAhost;
        ReactGA.initialize(initReactGAhost, { debug: false, alwaysSendToDefaultTracker: false });

    }

    componentDidMount() {
        const that = this;

        lang = this.state.scLang;

		if(iosLoad) {
            if(document.querySelector("#gRoot").shadowRoot.querySelector("#cbInput")) document.querySelector("#gRoot").shadowRoot.querySelector("#cbInput").addEventListener("touchend", function(e){
                if(e.cancelable) e.preventDefault()
                e.stopPropagation()
                e.target.focus()
            })
            if(document.querySelector("#gRoot").shadowRoot.querySelector("#moisInput")) document.querySelector("#gRoot").shadowRoot.querySelector("#moisInput").addEventListener("touchend", function(e){
                if(e.cancelable) e.preventDefault()
                e.stopPropagation()
                e.target.focus()
            })
            if(document.querySelector("#gRoot").shadowRoot.querySelector("#anneeInput")) document.querySelector("#gRoot").shadowRoot.querySelector("#anneeInput").addEventListener("touchend", function(e){
                if(e.cancelable) e.preventDefault()
                e.stopPropagation()
                e.target.focus()
            })
            if(document.querySelector("#gRoot").shadowRoot.querySelector("#cvcInput")) document.querySelector("#gRoot").shadowRoot.querySelector("#cvcInput").addEventListener("touchend", function(e){
                if(e.cancelable) e.preventDefault()
                e.stopPropagation()
                e.target.focus()
            })
			if(document.querySelector("#gRoot").shadowRoot.querySelector("#btn-divCheck")) document.querySelector("#gRoot").shadowRoot.querySelector("#btn-divCheck").addEventListener("touchend", function(e){
                e.preventDefault()
                e.stopPropagation()
				that.checkCgvHandleClick(e)
			})
			if(document.querySelector("#gRoot").shadowRoot.querySelector("#cgvTxt")) document.querySelector("#gRoot").shadowRoot.querySelector("#cgvTxt").addEventListener("touchend", function(e){
                if(e.cancelable) e.preventDefault()
                e.stopPropagation()
				that.btnCgvHandleClick(e)
			})
			if(document.querySelector("#gRoot").shadowRoot.querySelector(".html-btns")) {
                const htmlBtns = Array.from(document.querySelector("#gRoot").querySelectorAll(".html-btns"));
                for (let i = 0; i < htmlBtns.length; i++) {
                    htmlBtns[i].addEventListener("touchend", function(e){
                        if(e.cancelable) e.preventDefault();
                        e.stopPropagation();
                        that.btnsHtmlHandleClick(e);
                    });
                }

            }
			if(document.querySelector("#gRoot").shadowRoot.querySelector("#btn-prec-paiement")) document.querySelector("#gRoot").shadowRoot.querySelector("#btn-prec-paiement").addEventListener("touchend", function(e){
                if(e.cancelable) e.preventDefault()
                e.stopPropagation()
				that.valPrecedentHandleClick(e, 'clic Précédent sur le SLIDE Paiement', 'PRECEDENT')
			})
			if(document.querySelector("#gRoot").shadowRoot.querySelector("#btn-valider")) document.querySelector("#gRoot").shadowRoot.querySelector("#btn-valider").addEventListener("touchend", function(e){
                if(e.cancelable) e.preventDefault()
                e.stopPropagation()
                that.eventWidget('clic Valider sur le SLIDE Paiement', 'PAYER');
                that.handleSubmit(e)
            })
        }

        if(window.Stripe) {
            const stripeJs = window.Stripe(stripePK[returnHostMode(this.props.hostSelect.mode)]);
            this.props.handleStripeInit(stripeJs);
        } else {
            domRoot.querySelector('#stripe-js').addEventListener('load', () => {
                const stripeJs = window.Stripe(stripePK[returnHostMode(this.props.hostSelect.mode)]);
                this.props.handleStripeInit(stripeJs);
            });
        }

    }

	componentDidUpdate(prevProps, prevState, snapshot) {

		if (this.props.lang !== prevProps.lang) {
            lang = this.props.lang;
            this.setState({scLang: this.props.lang});
        }
		if (this.state.scLang !== prevState.scLang) {
            this.setState({scLang: this.state.scLang});
        }
		if(this.state.validateCGV !== prevState.validateCGV) {
			this.setState({validateCGV:this.state.validateCGV})
        }

		if(this.props.hostSelect.customStyle) {
			this.cl("sc - customize " + this.props.hostSelect.host);
			customizeCss(this.props.hostSelect.host, this.props.domRoot);
			window.addEventListener('resize', customizeCss(this.props.hostSelect.host, this.props.domRoot));
		}

		if (domRoot.querySelector(".html-btns") && domRoot.querySelector(".html-btns:not([clickEvent])")) {
            const htmlBtns = Array.from(domRoot.querySelectorAll(".html-btns:not([clickEvent])"));
            for (let i = 0; i < htmlBtns.length; i++) {
                htmlBtns[i].setAttribute("clickEvent", "true");
                htmlBtns[i].onclick = this.btnsHtmlHandleClick;
            }
		}
    }

    cl(view) {
        if((this.props && this.props.hostSelect && this.props.hostSelect.mode.indexOf("test") !== -1) || this.props.IP_IS_ADMIN) {
            if(Array.isArray(view)) view.forEach(el=>console.log(el));
            else console.log(view);
        }
    }

	pagesVues = (slide, order) => {
		if(order === undefined) order = 0;
		let tracker = window.location.host.split(".")[window.location.host.split(".").length - 2].replace(/-/g,"");
		if(this.props.hostSelect.mode === "prod" && !this.props.IP_IS_ADMIN) ReactGA.ga(tracker+'.send', 'pageview', 'Gustave ' + slideView[+slide + order]);
	}

	eventWidget = (actionSend, labelSend) => {
		if(labelSend==="FERMER WIDGET" || labelSend==="CLIC ORDERSTEP") actionSend += " " + slideView[+this.state.workflowStep + this.state.orderStep]
		let tracker = window.location.host.split(".")[window.location.host.split(".").length - 2].replace(/-/g,"");
		if(this.props.hostSelect.mode === "prod" && !this.props.IP_IS_ADMIN) ReactGA.ga(tracker+'.send', {hitType: "event", eventCategory: "Widget Gustave", eventAction: actionSend, eventLabel: labelSend})
    }

    handleSubmit = (ev) => {
        if(ev && ev.cancelable) ev.preventDefault();
        if(ev) ev.stopPropagation();

        let card = {
            number : saveCard.number.replace(/ /g,""),
            exp_month : saveCard.exp_month,
            exp_year : saveCard.exp_year,
            cvc : saveCard.cvc,
        };

        this.props.createPM(card);
    }

	handleKeyDown = (event) => { // gestion bug fraiche
		if(window.location.host==='www.fraiche-paris.fr' && (event.key===" " || event.key===32 || event.which===32)) {
			event.preventDefault();
			event.target.value += event.key;
		}
		if((event.keyCode===13 || event.which===13) && this.state.validateCGV && saveCard.number  && saveCard.number.length === type && saveCard.exp_year && saveCard.exp_month && saveCard.cvc && this.isNumberValide(saveCard.cvc,cvcType) && this.verifDateExp(saveCard.exp_month, saveCard.exp_year)) {
            this.eventWidget('touche Entrée sur le SLIDE Paiement', 'PAYER');
            this.handleSubmit();
        }
    }

	formatAutoSpace = (value) => {
		let numFormate = "";
        let numero = value.replace(/ /g,"").split("");

        if(numero[0] === "3") {type = 17;cvcType = 4}
        else {type = 19;cvcType = 3}

        if(type === 17) { // si amex
			for(let [index, num] of numero.entries()) {
				if(index === 4 || index === 10) numFormate += " ";
				if(+num >= 0 && +num < 10) numFormate += num;
			}
		} else { // si cb
			for(let [index, num] of numero.entries()) {
				if(index === 4 || index === 8 || index === 12) numFormate += " ";
				if(+num >= 0 && +num < 10) numFormate += num;
			}
		}
        return numFormate;
    }

	justNumber = (value) => {
		let numFormate = "";
        let numero = value.split("");

        for(let num of numero) {
            if(+num >= 0 && +num < 10) numFormate += num;
        }
        return numFormate;
    }

    verifDateExp = (mois, annee) => {
        let date = new Date();
        if(mois && annee) {
            if(+("20" + annee) > date.getFullYear() && +mois <= 12) return true;
            else if(+("20" + annee) === date.getFullYear() && +mois >= date.getMonth()+1 && +mois <= 12) return true;
            else return false;
        } else if(mois && +mois <= 12) return true;
        else if(annee && +("20" + annee) >= date.getFullYear()) return true;
        else return false;
    }

	isNumberValide = (value, lengthValue) => {
		if(value && value !== "" && value !== undefined) {
            var reg_number = `^[0-9]{${lengthValue}}$`;

            if(value.replace(/ /g,"").match(reg_number)) return true
            else return false
		}
    }
    checkCgvHandleClick = (e) => {
		if(e.cancelable) e.preventDefault()
        this.setState({validateCGV:!this.state.validateCGV})
    }
	btnCgvHandleClick = (e) => {//
		if(e.cancelable) e.preventDefault();
		window.open("https://www.mercigustave.co/index.php/cgu")
    }

	btnsHtmlHandleClick = (e) => {//
        if(e.cancelable) e.preventDefault();
		window.open(e.target.href, e.target.target);
    }

	valPrecedentHandleClick = (e, eventAction, eventLabel) => {
        if(e.cancelable) e.preventDefault();
		this.eventWidget(eventAction, eventLabel);
        this.props.setOrderStep(1);
	}
	validerHandleClick = (e, eventAction, eventLabel) => {
        if(e.cancelable) e.preventDefault();
		this.eventWidget(eventAction, eventLabel);
    }

    render(){

        const {card,validateCGV} = this.state

        return(

            <div style={{display:'flex',flexDirection:'column',width:'100%', position: 'relative'}}>
				<div>
                    <div className="txt-info-service">
                    {langSelect("valpinf").split("*")[0]} {window.location.host !== "www.editionsmr.fr" && <br />}{langSelect("valpinf").split("*")[1]} {window.location.host === "www.editionsmr.fr" && <br />}<span className="accentPhrase" style={{fontWeight:'600'}}>{langSelect("valpinf").split("*")[2]}</span> {langSelect("valpinf").split("*")[3]}
                    </div>
                    <div>
                        <div className="txt-slide-paiement">{langSelect("valcblabel")}</div>
                        <div style={{position:"relative"}}>
                            <Input id="cbInput" className="sc-inputs" maxLength={type} style={{width:'100%',marginBottom:16}} value={saveCard.number} placeholder='---- ---- ---- ----'
                            onChange={e=>{
                                e.target.value = this.formatAutoSpace(e.target.value)
                                saveCard.number = e.target.value
                                if(saveCard.number && saveCard.number.length === type) {
                                    this.setState({card:{...card,number:this.formatAutoSpace(e.target.value)}});
                                    sessionStorage.setItem("savedCard", JSON.stringify(saveCard));
                                    document.querySelector("#gRoot").shadowRoot.querySelector("#moisInput").focus();
                                }
                            }} onBlur={e=>{
                                saveCard.number = this.formatAutoSpace(e.target.value)
                                this.setState({card:{...card,number:this.formatAutoSpace(e.target.value)}});
                                sessionStorage.setItem("savedCard", JSON.stringify(saveCard));
                            }} onKeyDown={this.handleKeyDown}/>
                            {saveCard.number && saveCard.number !== "" && saveCard.number.length === type && <FontAwesomeIcon className="checkStyle" icon="check" />}
                        </div>
                    </div>
                    <div style={{display:'flex',flex:1,justifyContent:'space-between'}}>
                        <div>
                            <div className="txt-slide-paiement">{langSelect("valexplabel")}</div>
                            <div style={{position:"relative"}}>
                                <Input.Group compact>
                                    <Input id="moisInput" className="sc-inputs" maxLength="2" style={{width:50,borderRight:0}} value={saveCard.exp_month} placeholder='01' onChange={e=>{
                                    saveCard.exp_month = this.justNumber(e.target.value)
                                    this.setState({card:{...card,exp_month:this.justNumber(e.target.value)}});
                                    sessionStorage.setItem("savedCard", JSON.stringify(saveCard));
                                    if(saveCard.exp_month && saveCard.exp_month.length === 2) {
                                        document.querySelector("#gRoot").shadowRoot.querySelector("#anneeInput").focus()
                                    }
                                    }} onKeyDown={this.handleKeyDown}/>
                                    <Input style={{ width: 30, borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff' }} placeholder="/" disabled />
                                    <Input id="anneeInput" className="sc-inputs" maxLength="2" style={{width:50, borderLeft: 0}} value={saveCard.exp_year} placeholder='22' onChange={e=>{
                                    saveCard.exp_year = this.justNumber(e.target.value)
                                    this.setState({card:{...card,exp_year:this.justNumber(e.target.value)}});
                                    sessionStorage.setItem("savedCard", JSON.stringify(saveCard));
                                    if(saveCard.exp_year && saveCard.exp_year.length === 2) {
                                        document.querySelector("#gRoot").shadowRoot.querySelector("#cvcInput").focus()
                                    }
                                    }} onKeyDown={this.handleKeyDown}/>
                                </Input.Group>
                                {saveCard.exp_month && this.isNumberValide(saveCard.exp_month,2) && saveCard.exp_year && this.isNumberValide(saveCard.exp_year,2) && this.verifDateExp(saveCard.exp_month, saveCard.exp_year) && <FontAwesomeIcon className="checkStyle" style={{right:5}} icon="check" />}
                            </div>
                            {saveCard.exp_month && saveCard.exp_year && this.isNumberValide(saveCard.exp_month,2) && this.isNumberValide(saveCard.exp_year,2) && !this.verifDateExp(saveCard.exp_month, saveCard.exp_year) && <span style={{marginTop:5,color:'red'}}>{langSelect("msgdateexp")}</span>}
                        </div>

                        <div>
                            <div className="txt-slide-paiement">{langSelect("valcvvlabel")}</div>
                            <div style={{position:"relative"}}>
                                <Input id="cvcInput" className="sc-inputs" maxLength={cvcType} style={{width:100}} value={saveCard.cvc} placeholder='123' onChange={e=>{
                                saveCard.cvc = this.justNumber(e.target.value)
                                this.setState({card:{...card,cvc:this.justNumber(e.target.value)}});
                                sessionStorage.setItem("savedCard", JSON.stringify(saveCard));
                                if(saveCard.cvc && saveCard.cvc.length === cvcType) {
                                    document.querySelector("#gRoot").shadowRoot.querySelector("#btn-divCheck").focus()
                                }
                                }} onKeyDown={this.handleKeyDown}/>
                                {saveCard.cvc && this.isNumberValide(saveCard.cvc,cvcType) && <FontAwesomeIcon className="checkStyle" icon="check" />}
                            </div>
                        </div>
                    </div>
				</div>

				<div className="txt-valid-cgv">
                    <div id="btn-divCheck" style={{marginRight:8,cursor:"pointer"}} onClick={(e)=>{this.checkCgvHandleClick(e)}}>
                        {validateCGV ?
                            <Icon type="check-square" theme="filled" style={{pointerEvents:'none',fontSize:14}}/>
                        :
                            <div style={{padding:6,border:'1px solid black',width:14,pointerEvents:'none'}}></div>
                        }
                    </div>
					<span style={{color: 'rgba(0,0,0,.65)'}} dangerouslySetInnerHTML={{__html: langSelect(window.innerWidth <= 320? "valcondmobile" : "valcond")}}></span>
				</div>

                <div className="bas-slide-paiement">
                    <div className="div-assurance">
                        <div className="txt-trans-secur">{langSelect("valsectxt")}</div>
                        <div style={{display: 'flex', justifyContent: 'flex-start', width: '100%'}}>
                            <div className="div-imgs-paiement">
                                <div className="stripe_img">
                                    <img src={URL_CONFIG + '/widget/assets/stripe.png'} alt='stripe' />
                                </div>
                                <img src={URL_CONFIG + '/widget/assets/visa.png'} alt='visa' />
                                <img src={URL_CONFIG + '/widget/assets/mastercard.png'} alt='mastercard' />
                                <img src={URL_CONFIG + '/widget/assets/amex.png'} alt='amex' />
                            </div>
                        </div>
                    </div>

                    <div id="btns-paiement">
                        <Button id="btn-prec-paiement" className="widget-btns-sc" type='primary'
                        onClick={(e)=>{
                            e.preventDefault()
                            this.valPrecedentHandleClick(e, 'clic Précédent sur le SLIDE Paiement', 'PRECEDENT')
                        }}>{langSelect("prevbtn")}</Button>

                        <Button id="btn-valider" className="widget-btns-sc" loading={this.state.loading} type='primary' disabled={!validateCGV || !saveCard.number  || saveCard.number.length !== type || !saveCard.exp_year || !saveCard.exp_month || !saveCard.cvc || !this.isNumberValide(saveCard.cvc,cvcType) || !this.verifDateExp(saveCard.exp_month, saveCard.exp_year)} onClick={(e)=>{
                            e.preventDefault();
                            this.eventWidget('clic Valider sur le SLIDE Paiement', 'PAYER');
                            this.handleSubmit(e);
                        }}>{langSelect("paybtn")}</Button>
                    </div>
                </div>
            </div>
        )
    }
}

function langSelect(txt) {
	if (hostSelect[txt] && hostSelect[txt][lang]) return hostSelect[txt][lang];
    else if (TXTS_FILE && TXTS_FILE[txt] && TXTS_FILE[txt][lang]) return TXTS_FILE[txt][lang];
    else if (lang !== "FR") {
		if(txt === "prevbtn") return "Previous"
		if(txt === "paybtn") return "Validate"
		// slide Validation
		if(txt === "valpinf") {
            if(window.location.host !== "www.editionsmr.fr") return "Why am I being asked my credit card information?*Just to be charged*after your fitting!*And only for the items you’ll decide to keep."
            else return "You will be charged*after your fitting*and only for the items*you decide to keep."
        }
		if(txt === "valcblabel") return "Card number"
		if(txt === "valexplabel") return "Expiry date"
		if(txt === "valcvvlabel") return "CVV"
		if(txt === "valcond") return "I have read and agree to the<a id=\"cgvTxt\" class=\"html-btns\" style=\"text-decoration: underline; margin-left: 6px; touch-action: initial;\" href=\"https://www.mercigustave.co/index.php/cgu\" rel=\"noopener noreferrer\" target=\"_blank\">terms and conditions.</a>"
		if(txt === "valcondmobile") return "I have read and agree to the<a id=\"cgvTxt\" class=\"html-btns\" style=\"text-decoration: underline; margin-left: 6px; touch-action: initial;\" href=\"https://www.mercigustave.co/index.php/cgu\" rel=\"noopener noreferrer\" target=\"_blank\">terms and conditions.</a>"
		if(txt === "valsectxt") return "Secured transaction"

		if(txt === "msgdateexp") return "Invalid expiration date."
		if(txt === "msgnonplan") return "We have encountered an error related to your credit card, please check the information entered. If the problem persists, contact us at 06.74.69.48.96."
    } else if(lang === "FR") {

		if(txt === "prevbtn") return "Précédent"
		if(txt === "paybtn") return "Valider"
		// slide Validation
		if(txt === "valpinf") {
            if(window.location.host !== "www.editionsmr.fr") return "Pourquoi me demande-t-on ma carte ?*Tout simplement pour pouvoir vous débiter*après votre essayage !*Et uniquement pour les articles que vous déciderez de garder."
            else return "Vous serez uniquement débité*après votre essayage*et seulement pour les articles*que vous décidez de garder."
        }
		if(txt === "valcblabel") return "Numéro de la carte"
		if(txt === "valexplabel") return "Expiration"
		if(txt === "valcvvlabel") return "CVC"
		if(txt === "valcond") return "J'ai lu et j'accepte les<a id=\"cgvTxt\" class=\"html-btns\" style=\"text-decoration: underline; margin-left: 6px; touch-action: initial;\" href=\"https://www.mercigustave.co/index.php/cgu\" rel=\"noopener noreferrer\" target=\"_blank\">Conditions Générales de Vente.</a>"
		if(txt === "valcondmobile") return "J'ai lu et j'accepte les<a id=\"cgvTxt\" class=\"html-btns\" style=\"text-decoration: underline; margin-left: 6px; touch-action: initial;\" href=\"https://www.mercigustave.co/index.php/cgu\" rel=\"noopener noreferrer\" target=\"_blank\">CGV.</a>"
		if(txt === "valsectxt") return "Transaction sécurisée"

		if(txt === "msgdateexp") return "date d'expiration invalide."
		if(txt === "msgnonplan") return "Nous avons rencontré une erreur liée à votre carte bancaire, merci de vérifier les informations saisies. Si le problème persiste, contactez nous au 06.74.69.48.96."
    }
}